// Germany
export const locale = {
	lang: 'de',
	data: {
		
	}
};
